import React from "react";
import ApprovalIntegrationPanel from "../../../component/approvals/ApprovalIntegrationPanel";
import { hrApi } from "../api/hrApi";

export default function HrApprovalTab() {
    return (
        <ApprovalIntegrationPanel
            loadApprovals={() => hrApi.getHrApprovals()}
            infoBannerText="결재 → 인사 자동 연동: 휴가·출장·초과근무 결재 승인 완료 시 근태·휴가에 자동 반영됩니다. 행을 클릭하면 상세 내용을 확인하고 처리할 수 있습니다."
        />
    );
}
